// extracted by mini-css-extract-plugin
export default {"container":"Vwa-z","oos":"Wwa-z","selected":"Xwa-z","recommendedSize":"Ywa-z"};